import { CASES } from './constants';

/**
 * Action to update users in the store.
 *
 * This action is dispatched to update the users state in the Redux store.
 * It takes a payload containing the new users' data.
 *
 * @param {Object} payload - The new users data to be stored.
 * @returns {Object} The action object with type and payload.
 */
export const updateUsers = (payload) => {
    return { type: CASES.UPDATE_USERS, payload };
};
